/**
 * This is the image Lazy-loader service
 */

const $objects = [ function () {
    return {
        merge: function(one, two) {
            for (let p in two) {
                if ( two.hasOwnProperty(p)) {
                    try {
                        // Property in destination object set; update its value.
                        if ( two[p].constructor === Object ) {
                            one[p] = this.merge(one[p], two[p]);
                        } else {
                            one[p] = two[p];
                        }
                    } catch(e) {
                        // Property in destination object not set; create it and set its value.
                        one[p] = two[p];
                    }
                }
            }
            return one;
        }
    };
}];

export default $objects;
